export const ROLE = {
    SOCIELITEADMIN: 'socielite_admin',
    UNIVERSITYADMIN: 'university_admin',
    STUDENT: 'student',
    STUDENTREPRESENTATIVE: 'student_representative'
}
